import { render } from "./VendorCredit.vue?vue&type=template&id=379f6e82"
import script from "./VendorCredit.vue?vue&type=script&lang=js"
export * from "./VendorCredit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__